let language = {
    RANDOM_DESIGN_ITEM_INFO_DELETE_ITEM_TITLE: "删除",
    RANDOM_DESIGN_ITEM_INFO_VALIDATE_TITLE_CONTENT: "是否移除当前的图库比率 ",
    RANDOM_DESIGN_ITEM_INFO_DELETE_ITEM_TITLE_CONTENT: "是否移除当前的图库比率 ",
}
export { language }